import { render, staticRenderFns } from "./DetailReports.vue?vue&type=template&id=68e3c338&scoped=true&"
import script from "./DetailReports.vue?vue&type=script&lang=js&"
export * from "./DetailReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e3c338",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68e3c338')) {
      api.createRecord('68e3c338', component.options)
    } else {
      api.reload('68e3c338', component.options)
    }
    module.hot.accept("./DetailReports.vue?vue&type=template&id=68e3c338&scoped=true&", function () {
      api.rerender('68e3c338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/accounting/DetailReports.vue"
export default component.exports